import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { IsLoggedIn } from '@grandvisionhq/auth';
import { useIntl } from '@grandvisionhq/state';
import { useStoreFinderContext, Components, Hooks } from '@grandvisionhq/stores-v2';
import { aabPreferredStoreClickEvent } from '../../../data-layer/actions.js';
import PreferredStoreTile from '../../PreferredStoreTile/PreferredStoreTile.js';

const { HighlightPreferredStore  } = Components;
const { useGetPreferredStore  } = Hooks;
const getStoreAppointmentType = (store, appointmentTypeId)=>{
    var ref;
    return store === null || store === void 0 ? void 0 : (ref = store.appointmentTypes) === null || ref === void 0 ? void 0 : ref.find((appointmentType)=>appointmentType.id === appointmentTypeId && appointmentType.isAvailableInStore
    );
};
const HighlightPreferredStoreContainer = ({ applicableAppointmentTypeId  })=>{
    const { getLabel  } = useIntl();
    const { setPreferredStore  } = useStoreFinderContext();
    const { data: store1  } = useGetPreferredStore();
    const title = getLabel('stores.component.storeFinder.preferredStoreTile.title');
    const showPreferredStore = applicableAppointmentTypeId ? !!getStoreAppointmentType(store1, applicableAppointmentTypeId) : true;
    React.useEffect(()=>{
        if (store1 && showPreferredStore) {
            setPreferredStore(store1);
        }
    }, [
        store1,
        setPreferredStore,
        showPreferredStore
    ]);
    const handleOnClickPreferredStoreTile = (store)=>{
        DataLayer.pushEvent(aabPreferredStoreClickEvent({
            store
        }));
    };
    if (!store1 || !showPreferredStore) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(HighlightPreferredStore, {
        title: title
    }, /*#__PURE__*/ React.createElement(PreferredStoreTile, {
        store: store1,
        onClick: handleOnClickPreferredStoreTile
    }));
};
var HighlightPreferredStore$1 = ((props)=>/*#__PURE__*/ React.createElement(IsLoggedIn, null, /*#__PURE__*/ React.createElement(HighlightPreferredStoreContainer, swcHelpers.extends({}, props)))
);

export { HighlightPreferredStore$1 as default };
//# sourceMappingURL=HighlightPreferredStoreContainer.js.map
